import { render, staticRenderFns } from "./pay-reconciliation.vue?vue&type=template&id=23c48aa7&scoped=true"
import script from "./pay-reconciliation.vue?vue&type=script&lang=js"
export * from "./pay-reconciliation.vue?vue&type=script&lang=js"
import style0 from "./pay-reconciliation.vue?vue&type=style&index=0&id=23c48aa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c48aa7",
  null
  
)

export default component.exports